import { useState, useEffect, useRef } from "react";

const CustomAutoSearch = ({ filteredList = [], fieldName, setFieldValue, initialValue, doOnChange = null, resetValue = null }) => {
    const [searchText, setSearchText] = useState(initialValue ? initialValue.toString() : "");
    const [showList, setShowList] = useState(false);
    const autoCompleteRef = useRef(null);
    const inputRef = useRef(null);

    const handleChange = (e) => {
        setSearchText(e.target.value);
        setFieldValue(fieldName,e.target.value);

        if(doOnChange) doOnChange(e.target.value);
    };

   const handleSelect = (id) => {
        const selectedItem = filteredList.find(item => item.id === id);
        if (selectedItem) {
            setSearchText(selectedItem.title);

            setFieldValue(fieldName,selectedItem.title);

            if(doOnChange) doOnChange(selectedItem.title);
        }
        setShowList(false);
    };

    useEffect(() => {
        setShowList(document.activeElement === inputRef.current || document.activeElement === autoCompleteRef.current);
    }, [searchText]);

    useEffect(() => {
        setSearchText(initialValue ? initialValue.toString() : "");
    }, [initialValue,resetValue]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // Optionally filter or select something
            console.log('Enter key pressed');
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (autoCompleteRef.current && !autoCompleteRef.current.contains(event.target)) {
                setShowList(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const filteredDisplayList = filteredList
        .filter(item =>
            item.title?.toLowerCase().includes(searchText.toLowerCase())
        )
        .slice(0, 5);

    return (
        <div ref={autoCompleteRef} className="position-relative custom-auto-search">
            <div>
                <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChange}
                    value={searchText}
                    onKeyDown={handleKeyPress}
                    ref={inputRef}
                />
                {/* <span className="search-icon"><i className="fa-solid fa-magnifying-glass"></i></span> */}
                {/* {searchText && (
                    <span className="clear-btn" onClick={() => setSearchText("")}>
                        <img src={getImages('search-cross.svg')} alt="Clear" />
                    </span>
                )} */}
            </div>

            {/* Desktop List */}
            <div className={`cs-search-list ${searchText && showList ? "d-none d-lg-block" : "d-none"}`}>
                {filteredDisplayList.length === 0 ? (
                    <div className="autocomplete-items text-center pd-sm-title">Data not found!</div>
                ) : (
                    filteredDisplayList.map((option, index) => (
                        <div key={index} style={{ cursor: "pointer" }} onClick={() => handleSelect(option.id)}>
                            <div className="autocomplete-items d-flex align-items-center">
                                <div className="cssl-content">
                                    <div className="pd-sm-title">{option.title}</div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Mobile List */}
            <div className="cs-search-list d-lg-none" style={{ display: searchText && showList ? "block" : "none" }}>
                {filteredDisplayList.length === 0 ? (
                    <div className="autocomplete-items text-center pd-sm-title">Data not found!</div>
                ) : (
                    filteredDisplayList.map((option, index) => (
                        <div key={index} style={{ cursor: "pointer" }} onClick={() => handleSelect(option.id)}>
                            <div className="autocomplete-items d-flex align-items-center">
                                <div className="cssl-content">
                                    <div className="pd-sm-title">{option.title}</div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default CustomAutoSearch;
